import { render, staticRenderFns } from "./LeaderboardHeader.vue?vue&type=template&id=741a1b0e&scoped=true&"
import script from "./LeaderboardHeader.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardHeader.vue?vue&type=style&index=0&id=741a1b0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741a1b0e",
  null
  
)

export default component.exports